module.exports = __webpack_public_path__ + "static/media/title_shorai_simulation.e2c49740.svg";